package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2023_12_22_Day_1
import com.veldekar.components.logs.Log_2023_12_22_Day_2
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2023-12-22")
@Composable
public fun Log_2023_12_22(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Portal to Zedj",
        ogTitle = "Portal to Zedj",
        date = LocalDate(2_023, 12, 22),
        ogDescription = "After winning bets at the Hexagon Battle, the heroes teleport through a portal to begin their journey to Zedj.",
        ogImage = "ai/2023-12-22.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-39", dateString = "Newgrowth 39")
        Log_2023_12_22_Day_1()
        SessionDayHeader(dayId = "newgrowth-40", dateString = "Newgrowth 40")
        Log_2023_12_22_Day_2()
    }
}
